import { LitElement, html } from 'https://unpkg.com/lit@3.1.2/index.js?module';


export class PromoBanner extends LitElement {
  static properties = {
    props: { type: Object },
  };

  jsonData = (() => {
    const el = document.getElementById('promoBannerMappingBlocks');
    if (!el || !el.textContent) {
      console.warn('[PromoBanner] Missing #promoBannerMappingBlocks element or content');
      return null;
    }

    try {
      const data = JSON.parse(el.textContent);
      return data;
    } catch (e) {
      console.warn('[PromoBanner] Failed to parse promo banner data:', e);
      return null;
    }
  })();

  triggerDiscountEvent() {
    this.applyDiscount();
  }

  applyDiscount() {
    if (!this.jsonData) return;

    const props = this.props || {};
    const productTags = Array.isArray(props.productTags)
      ? props.productTags.map((t) => String(t).toLowerCase().trim())
      : [];
    const mappingItems = this.jsonData.promo_banner_mapping_blocks || [];

    const targetItem = mappingItems.find((item) => {
      const tag = String(item.product_tag || '').toLowerCase().trim();
      return tag && productTags.includes(tag);
    });

    if (!targetItem) {
      // console.warn('[PromoBanner] No mapping match', {
      //   productTags,
      //   mappings: mappingItems,
      //   currency: props.currencyCode,
      //   locale: props.locale,
      //   rawProps: props,
      // });
      return;
    }

    const basePriceCents = Number(props.productPrice) || 0;
    const comparePriceCents = Number(props.comparePrice) || basePriceCents;

    const discountPercent = Number(targetItem?.discount_percentage) || 0;

    if (!discountPercent || discountPercent >= 100 || !basePriceCents) {
      console.warn('[PromoBanner] Invalid discount or price', {
        discountPercent,
        basePriceCents,
        comparePriceCents,
        currency: props.currencyCode,
        locale: props.locale,
        targetItem,
      });
      return;
    }

    // Use ceil to avoid fractional-cent rounding down (e.g., 99.99 * 0.8 -> 79.992 -> 80.00)
    const discountedPriceCents = Math.max(0, Math.ceil(basePriceCents * (1 - discountPercent / 100)));
    const originalPriceCents = Math.max(comparePriceCents, basePriceCents);

    const totalDiscountPercent = Math.round(
      ((originalPriceCents - discountedPriceCents) / originalPriceCents) * 100,
    );

    const detail = {
      discountedPrice: discountedPriceCents,
      originalPrice: originalPriceCents,
      discountPercentage: totalDiscountPercent,
    };

    if (targetItem.discount_code?.trim()) {
      detail.discountCode = targetItem.discount_code;
    }

    if (targetItem.message?.trim()) {
      detail.message = targetItem.message;
    }

    // console.debug('[PromoBanner] Dispatching discount', {
    //   productTags,
    //   targetItem,
    //   detail,
    //   currency: props.currencyCode,
    //   locale: props.locale,
    //   basePriceCents,
    //   comparePriceCents,
    // });

    this.dispatchEvent(new CustomEvent('promo-discount-ready', {
      bubbles: true,
      composed: true,
      detail,
    }));
  }

  render() {
    return html``;
  }

  updated(changedProperties) {
    if (changedProperties.has('props')) {
      this.triggerDiscountEvent();
    }
  }
}

customElements.get('promo-banner') || customElements.define('promo-banner', PromoBanner);
